var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconEnterLight = function SvgIconEnterLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.538 12.95V5h1.1v7.95c0 .654-.497 1.15-1.15 1.15h-9.55V13h9.55a.104.104 0 0 0 .038-.006l.003-.001.003-.005a.104.104 0 0 0 .006-.038Z",
    fill: "#121619"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m6.356 12.754 4.2-4.05.763.792-4.195 4.045a.086.086 0 0 0-.023.046l.016.015 4.2 4-.759.796-4.185-3.986c-.53-.445-.456-1.219-.024-1.65l.007-.008Z",
    fill: "#121619"
  })));
};
export default SvgIconEnterLight;